import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    ContentTotalValue,
    Text,
    TextBold,
} from "../styled";
import {formatCurrency} from "@dropDesk/utils/helpers/common";
import React from "react";
import {observer} from "mobx-react";
import {
    PaymentSubscriptionSimulateEntity
} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_simulate.entity";


const Header = observer((
    {
        simulate,
    }: {
        simulate?: PaymentSubscriptionSimulateEntity
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <ContentTotalValue>
            <TextBold size={39} color={colors.text}>
                {formatCurrency(simulate?.totalToday ?? 0)}
                <Text size={16} color={colors.text}>&nbsp;hoje</Text>
            </TextBold>
        </ContentTotalValue>
    );
});
export default Header;
